import type { VideoQuality } from '../webrtc/useLocalMedia'
import { Dialog } from './ui/Dialog'
import { Select } from './ui/Select'
import { Button } from './ui/Button'

interface DevicePickerProps {
  open: boolean
  onClose: () => void
  devices: {
    audioInput: MediaDeviceInfo[]
    videoInput: MediaDeviceInfo[]
    audioOutput: MediaDeviceInfo[]
  }
  selectedAudioIn: string | null
  selectedVideoIn: string | null
  selectedAudioOut: string | null
  quality: VideoQuality
  onAudioIn: (id: string) => void
  onVideoIn: (id: string) => void
  onAudioOut: (id: string) => void
  onQuality: (q: VideoQuality) => void
}

const QUALITY_OPTIONS = [
  { value: 'low',   label: 'Niedrig  (360p, 15fps)' },
  { value: 'medium',label: 'Mittel   (720p, 30fps)' },
  { value: 'high',  label: 'Hoch     (1080p, 30fps)' },
  { value: 'hd',    label: 'HD+      (1440p, 30fps)' },
  { value: '4k',    label: '4K       (2160p, 30fps)' },
]

function toOptions(list: MediaDeviceInfo[]) {
  return list.map((d, i) => ({
    value: d.deviceId || `device-${i}`,
    label: d.label || `Gerät ${i + 1}`,
  }))
}

export function DevicePicker({
  open,
  onClose,
  devices,
  selectedAudioIn,
  selectedVideoIn,
  selectedAudioOut,
  quality,
  onAudioIn,
  onVideoIn,
  onAudioOut,
  onQuality,
}: DevicePickerProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Geräte & Qualität"
      footer={<Button onClick={onClose}>Fertig</Button>}
    >
      <div className="stack">
        <p className="muted" style={{ margin: 0, fontSize: '0.85rem' }}>
          Deine Auswahl wird als Standard gespeichert und beim nächsten Beitritt automatisch verwendet.
        </p>
        <Select
          label="Videoqualität"
          value={quality}
          onValueChange={(v) => onQuality(v as VideoQuality)}
          options={QUALITY_OPTIONS}
          hint="Niedrigere Qualität spart Bandbreite"
        />
        <Select
          label="Mikrofon"
          value={selectedAudioIn}
          onValueChange={onAudioIn}
          options={toOptions(devices.audioInput)}
          hint="Standard-Eingabegerät"
        />
        <Select
          label="Kamera"
          value={selectedVideoIn}
          onValueChange={onVideoIn}
          options={toOptions(devices.videoInput)}
          hint="Standard-Kamera"
        />
        <Select
          label="Lautsprecher"
          value={selectedAudioOut}
          onValueChange={onAudioOut}
          options={toOptions(devices.audioOutput)}
          hint="Standard-Ausgabegerät — nicht von allen Browsern unterstützt"
        />
      </div>
    </Dialog>
  )
}
